import type { AppState } from './types';

import * as ActionTypes from 'src/state/action-types';

export const initialState: AppState = {
  currentPath: '/',
  previousPath: null,
};

export default function appReducer(
  state: AppState = initialState,
  action: ActionTypes.ActionTypes
): AppState {
  switch (action.type) {
    case ActionTypes.APP_NAVIGATED:
      return {
        ...state,
        previousPath: state.currentPath,
        currentPath: action.payload.path,
      };

    default:
      return state;
  }
}
